import React, { FC, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useQueryParameters from 'hooks/useQueryParameters';
import LoadingPage from 'components/LoadingPage';

import { selectCreditApplication } from 'state/creditApplication';
import useTranslate from 'hooks/useTranslate';
import { setPrescreenId } from 'state/prescreen';

interface PropTypes {
  virtualLookupCall: (id: string) => Promise<void>;
}

const LookupPrescreenId: FC<PropTypes> = props => {
  const t = useTranslate();
  const { prescreenId } = useQueryParameters();
  const { virtualLookupCall } = props;
  const fetched = useRef<boolean>(false);
  const { firstName } = useSelector(selectCreditApplication);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!prescreenId) {
      throw new Error('prescreenId required for virtual lookup.');
    }
    // Ensure we only fetched once.
    if (!fetched.current) {
      fetched.current = true;
      dispatch(setPrescreenId(prescreenId as string));
      virtualLookupCall(prescreenId);
    }
  }, [dispatch, prescreenId, virtualLookupCall]);

  const headerTitle = firstName
    ? t('batchPrescreen.prescreenLookup.welcome', { firstName: firstName })
    : t('batchPrescreen.prescreenLookup.loading');

  return <LoadingPage headerTitle={headerTitle} />;
};

export default LookupPrescreenId;
